import type { ToolkitPanel } from './types';

interface BottomTabBarProps {
  activePanel: ToolkitPanel;
  onPanelChange: (panel: ToolkitPanel) => void;
}

const tabs: { panel: ToolkitPanel; label: string; icon: string }[] = [
  { panel: 'check-in', label: 'Check-In', icon: '✅' },
  { panel: 'walk-up', label: 'Walk-Up', icon: '➕' },
  { panel: 'lookup', label: 'Lookup', icon: '🔍' },
  { panel: 'qr-scan', label: 'QR Scan', icon: '📷' },
  { panel: 'gx', label: 'GX Feed', icon: '📡' },
  { panel: 'dashboard', label: 'Dashboard', icon: '📈' },
  { panel: 'stats', label: 'Stats', icon: '📊' },
  { panel: 'contacts', label: 'Contacts', icon: '🚨' },
  { panel: 'panel', label: 'Panel', icon: '⚡' },
];

const barStyle: React.CSSProperties = {
  position: 'fixed',
  bottom: '64px',
  left: 0,
  right: 0,
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  background: '#0a1f14',
  paddingBottom: 'env(safe-area-inset-bottom, 0px)',
  paddingTop: '4px',
  zIndex: 1000,
};

const tabBaseStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '44px',
  minHeight: '44px',
  padding: '6px 4px',
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  color: '#a0a0a0',
  fontSize: '10px',
  fontWeight: 500,
  lineHeight: 1.2,
  WebkitTapHighlightColor: 'transparent',
};

const activeTabStyle: React.CSSProperties = {
  ...tabBaseStyle,
  color: '#c9a84c',
};

const iconStyle: React.CSSProperties = {
  fontSize: '20px',
  marginBottom: '2px',
};

export function BottomTabBar({ activePanel, onPanelChange }: BottomTabBarProps) {
  return (
    <nav style={barStyle} aria-label="Toolkit navigation">
      {tabs.map((tab) => {
        const isActive = activePanel === tab.panel;
        return (
          <button
            key={tab.panel}
            type="button"
            style={isActive ? activeTabStyle : tabBaseStyle}
            onClick={() => onPanelChange(tab.panel)}
            aria-current={isActive ? 'page' : undefined}
            aria-label={tab.label}
          >
            <span style={iconStyle} aria-hidden="true">{tab.icon}</span>
            <span>{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
